import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;
const Blockly = GlobalImport.getBlockly();

export class FunctionBlock extends AbstractBlock {
  FUNCTION_NAME = 'FUNCTION_NAME';

  constructor(name: string) {
    super(name, t.to('ブロック定義', 'function_def'));
  }
  defineBlock(block: BlockType): void {
    ColorSettings.setMoreColor(block);
    ShapeSettings.setSceneStartShape(block);

    // フィールド
    const functionName = new Blockly.FieldTextInput(t.to('ブロック名', 'block_name'));

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('ブロック', 'function_def_1') + '[')
      .appendField(functionName, this.FUNCTION_NAME)
      .appendField(']' + t.to('を', 'function_def_2'));
    const arg = new Blockly.FieldTextInput('');
    block
      .appendDummyInput()
      .appendField(t.to('パラメータ', 'function_def_3') + ' [')
      .appendField(arg, 'arg')
      .appendField(']' + t.to('を受け付けるように定義', 'function_def_4'));

    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const functionName = CodeSetting.getFieldValue(block, this.FUNCTION_NAME);
    const input = CodeSetting.getSubstatementCode(block);
    const arg = CodeSetting.getFieldValue(block, 'arg');

    const str = `window.${functionName} = function( ${arg} ){
      try{
        // let scene = document.querySelector("a-scene");;
        // if(!scene){ scene = document.createElement("a-scene"); }
        // let parent = scene
        
        ${input}
      }catch(error){
        // console.log(error);
      }
		}`;
    return str;
  }
}
